import { ssoApi } from "@sso/apis";
import { ApiPageResponse, ExtendedAPIAccountList } from "@sso/types";

import { CacheKeys } from "../cacheKeys";
import { Endpoints } from "../endpoints";

export const accountsApi = ssoApi.enhanceEndpoints({ addTagTypes: [CacheKeys.API_ACCOUNTS] }).injectEndpoints({
  endpoints: builder => ({
    apiAccounts: builder.query<ApiPageResponse<ExtendedAPIAccountList>, string>({
      query: query => ({ url: `${Endpoints.API_ACCOUNTS}?${query}` }),
      providesTags: [CacheKeys.API_ACCOUNTS],
    }),
    apiAccountsByUserOrg: builder.query<ExtendedAPIAccountList[], null | number | void>({
      query: (orgId = null) => ({ url: orgId != null ? `${Endpoints.API_ACCOUNTS}/GetByUserOrg?orgId=${orgId}` : `${Endpoints.API_ACCOUNTS}/GetByUserOrg` }),
    }),
  }),
});

export const { useApiAccountsQuery, useApiAccountsByUserOrgQuery } = accountsApi;
